import { memo } from "react";
import { Dialog } from "../../../../components/primitives/feedback/Dialog";
import { DocumentDetail } from "./DocumentDetail";

/** The minimal shape needed to open this dialog — a document id plus whatever title/url is
 *  already on hand for the header, before the full document loads. A caller that only has a
 *  source id can open the dialog with just `{ id }`. */
export interface DocumentDetailDialogTarget {
  id: string;
  title?: string | null;
  url?: string | null;
}

export interface DocumentDetailDialogProps {
  item: DocumentDetailDialogTarget | null;
  onClose: () => void;
}

/** Opens a read-only dialog showing a corpus document's metadata and scorecard, with a link to
 *  its trace page for how it was extracted and admitted. Title is taken from the already-loaded
 *  item so the dialog header is immediately visible. */
export const DocumentDetailDialog = memo(function DocumentDetailDialog({
  item,
  onClose,
}: DocumentDetailDialogProps) {
  return (
    <Dialog
      open={item !== null}
      onClose={onClose}
      title={item?.title ?? item?.url ?? "Document details"}
      dividers
    >
      {item !== null && <DocumentDetail sourceId={item.id} />}
    </Dialog>
  );
});
